var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.043 15.857c-.099.249-1.294 1.286-2.541 1.286c-1.852 0-3.073-.673-3.073-2.014c0-1.234 1.543-1.826 3.437-2.512c2.284-.771 3.42-2.134 3.42-4.003c0-2.228-1.809-3.47-4.526-3.47c-1.436 0-3.274.745-3.758 1.242l1.14 1.328c.458-.235 1.328-.857 2.6-.857c1.908 0 2.83.853 2.83 1.757c0 1.24-.7 1.81-2.632 2.516c-2.366.87-4.226 1.916-4.226 3.862c0 2.048 1.483 3.865 4.788 3.865c1.35 0 2.914-.745 3.784-1.662z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolo);
export default __webpack_public_path__ + "static/media/solo.c406d7fd61ff72acbaaec8ad21ec1588.svg";
export { ForwardRef as ReactComponent };